import { isValidDateString } from '@/common/utils/dateValidator'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { isFuture } from 'date-fns'
import { z } from 'zod'

const geosSchema = z.object({
  value: z.string().optional(),
  type: z.string().optional(),
})

export const companyPriceSurveySchema = z.object({
  survey_conducted_at: z
    .string({ message: 'Campo obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato DD/MM/AAAA' })
    .refine(isValidDateString, { message: 'Data inválida' })
    .refine(
      (value) => {
        const [day, month, year] = value.split('/')
        return !isFuture(new Date(`${year}-${month}-${day}`))
      },
      { message: 'Data não pode ser no futuro' },
    ),
  geo_geoables_attributes: z.array(geosSchema).min(1, 'Pelo menos 1 cidade deve ser especificada na pesquisa de preço'),
  price_survey_products_attributes: z
    .array(
      z.object({
        id: z.string().optional(),
        product_id: z.string(),
        display_name: z.string().optional(),
        price: z.string({ message: 'Campo obrigatório' }).refine(unFormatCurrency, { message: 'Campo obrigatório' }),
      }),
    )
    .min(1, 'Pelo menos 1 preço deve ser incluso na pesquisa de preço'),
  evidences_attachments_attributes: z.array(
    z.object({
      id: z.string(),
      file: z.custom<File>().optional(),
      fileName: z.string(),
      currentFileUrl: z.string(),
    }),
  ),
})

export type CompanyPriceSurveyValidationSchema = z.infer<typeof companyPriceSurveySchema>
